import { render } from "./DropdownEditTextBasedStrategy.vue?vue&type=template&id=0538a6bc&scoped=true"
import script from "./DropdownEditTextBasedStrategy.vue?vue&type=script&lang=js"
export * from "./DropdownEditTextBasedStrategy.vue?vue&type=script&lang=js"

import "./DropdownEditTextBasedStrategy.vue?vue&type=style&index=0&id=0538a6bc&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-0538a6bc"

export default script